module.exports = __webpack_public_path__ + "img/Stemness-PRCA_10X_AIC.1906e5b3.png";